import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import { validateEmail, validatePassword } from "pages/formTools";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export interface ResetValues {
  code: string;
  password: string;
  confirmPassword: string;
}

export const validateResetEmail = (data: { email: string }): FieldErrorMap => ({
  email: validateEmail({
    name: ta("fields.email"),
    value: data.email,
    required: true,
  }),
});

// The same password rules as sign-up.
export const validateReset = (data: ResetValues): FieldErrorMap => ({
  code: /^\d{6}$/.test(data.code.trim()) ? null : ta("common.code_digits"),
  password: validatePassword({
    name: ta("fields.password"),
    value: data.password,
    required: true,
  }),
  confirmPassword:
    data.confirmPassword === data.password
      ? null
      : ta("common.password_mismatch"),
});
